<template>
  <div class="app-body" ref="appContent">
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="120px"
    >
      <el-row :gutter="16">
        <el-col :xl="8" :lg="8" :md="8">
          <el-form-item label="外销合同编号：" prop="agreementCode">
            <order-drop v-model="dataForm.agreementCode" placeholder="请输入外销合同编号"
                        :disabled="!codeCanEdit" @change="agreementCodeChange"></order-drop>
          </el-form-item>
        </el-col>
        <el-col :xl="8" :lg="8" :md="8">
          <el-form-item label="品番：" prop="orderDetailIds">
            <el-select v-model="dataForm.orderDetailIds" placeholder="请选择品番" size="mini" style="width: 100%;"
                       :multiple="true">
              <el-option v-for="item in orderDetailList" :key="item.id" :label="item.product.desName"
                         :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xl="2" :lg="4" :md="6">
          <el-button type="primary" @click="readMaterialList()" size="mini"
          >读取合同原料
          </el-button
          >
        </el-col>
        <el-col :lg="6" :md="6" class="flex" style="margin-top:10px;">
          <div style="color:red">操作提示：请先输入合同号。</div>
        </el-col>
      </el-row>

      <el-card>
        <div slot="header" class="card-header">
          <div>原料明细</div>
          <div>
            <el-button
                size="mini"
                icon="el-icon-plus"
                @click="addRow()"
                type="primary"
            >增加原料
            </el-button
            >
          </div>
        </div>
        <el-table
            :data="dataForm.detailList"
            border
            style="width: 100%"
            ref="table"
            :max-height="maxTableHeight"
        >
          <el-table-column
              type="index"
              width="50"
              label="行号"
              header-align="center"
              align="center"
          ></el-table-column>
          <el-table-column label="原料名称" align="center" min-width="200">
            <template slot-scope="scope">
              <el-form-item
                  :prop="'detailList.' + scope.$index + '.productName'"
                  :rules="detailRule.productName"
                  label-width="0"
                  style="margin-top: 20px"
              >
                <el-input
                    :disabled="str2Bool(scope.row.productId)"
                    v-model="scope.row.productName"
                    placeholder="请输入品名"
                    size="mini"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
              label="颜色"
              prop="color"
              header-align="center"
              align="center"
              width="min-130"
          >
            <template slot-scope="scope">
              <el-form-item
                  :prop="'detailList.' + scope.$index + '.color'"
                  label-width="0"
                  style="margin-top: 20px"
              >
                <el-input
                    v-model="scope.row.color"
                    placeholder="请输入颜色"
                    :disabled="str2Bool(scope.row.productId)"
                    size="mini"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
              label="规格"
              prop="size"
              header-align="center"
              align="center"
              min-width="130"
          >
            <template slot-scope="scope">
              <el-form-item
                  :prop="'detailList.' + scope.$index + '.size'"
                  label-width="0"
                  style="margin-top: 20px"
              >
                <el-input
                    v-model="scope.row.size"
                    placeholder="请输入规格"
                    :disabled="str2Bool(scope.row.productId)"
                    size="mini"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
              label="幅宽"
              header-align="center"
              align="center"
              min-width="130"
          >
            <template slot-scope="scope">
              <el-form-item
                  :prop="'detailList.' + scope.$index + '.attr1'"
                  label-width="0"
                  style="margin-top: 20px"
              >
                <el-input
                    v-model="scope.row.attr1"
                    placeholder="请输入幅宽"
                    :disabled="str2Bool(scope.row.productId)"
                    size="mini"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
              label="克重"
              header-align="center"
              align="center"
              min-width="130"
          >
            <template slot-scope="scope">
              <el-form-item
                  :prop="'detailList.' + scope.$index + '.attr2'"
                  label-width="0"
                  style="margin-top: 20px"

              >
                <el-input
                    v-model="scope.row.attr2"
                    placeholder="请输入克重"
                    :disabled="str2Bool(scope.row.productId)"
                    size="mini"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
              label="原料数量"
              header-align="center"
              align="center"
              width="130"
          >
            <template slot-scope="scope">
              <el-form-item
                  :prop="'detailList.' + scope.$index + '.count'"
                  :rules="detailRule.count"
                  label-width="0"
                  style="margin-top: 20px"
              >
                <el-input v-model="scope.row.count" size="mini"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
              label="采购单价"
              header-align="center"
              align="center"
              width="130"
          >
            <template slot-scope="scope">
              <el-form-item
                  :prop="'detailList.' + scope.$index + '.amount'"
                  :rules="detailRule.amount"
                  label-width="0"
                  style="margin-top: 20px"
              >
                <el-input v-model="scope.row.amount" size="mini"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
              label="供应商"
              header-align="center"
              align="center"
              width="230"
          >
            <template slot-scope="scope">
              <el-form-item
                  :prop="'detailList.' + scope.$index + '.companyId'"
                  :rules="detailRule.companyId"
                  label-width="0"
                  style="margin-top: 20px"
              >
                <el-select size="mini" v-model="scope.row.companyId" style="width: 100%" :filterable="true">
                  <el-option v-for="item in companyList" :key="item.id" :value="item.id" :label="item.name"></el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
              label="收货工厂"
              header-align="center"
              align="center"
              width="230"
          >
            <template slot-scope="scope">
              <el-form-item
                  :prop="'detailList.' + scope.$index + '.storageId'"
                  :rules="detailRule.storageId"
                  label-width="0"
                  style="margin-top: 20px"
              >
                <el-select size="mini" v-model="scope.row.storageId" style="width: 100%" :filterable="true">
                  <el-option v-for="item in storageList" :key="item.id" :value="item.id" :label="item.name"></el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="center" label="操作" width="100">
            <template slot-scope="scope">
              <el-button
                  type="text"
                  icon="el-icon-remove"
                  size="mini"
                  @click="delRow(scope.$index, scope.row, 'detailList')"
              >
                移除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </el-form>
    <div class="footer">
      <el-button @click="goBackStep()" size="mini" v-if="type == 'next'">上一步</el-button>
      <el-button @click="cancel()" size="mini" v-if="type == 'single'">{{
          $t('cancel')
        }}
      </el-button>
      <el-button v-if="type !== 'single'" type="warning" size="mini" @click="go2Next()">跳过
      </el-button>
      <el-button type="primary" size="mini" @click="dataFormSubmitHandle()">{{
          type == 'single' ? '确定' : '下一步'
        }}
      </el-button>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import SingleFileUpload from '@/components/SingleFileUpload'
import moment from 'moment'
import { moneyValidator, isNumber } from '@/utils/validate'

export default {
  components: { SingleFileUpload },
  data () {
    return {
      agreementId: '',
      id: '',
      dataForm: {},
      type: 'single',
      maxTableHeight: 100,
      storageList: [],
      companyList: [],
      orderDetailList: []
    }
  },
  computed: {
    codeCanEdit () {
      if (this.agreementId) {
        return false
      }
      return true
    },
    dataRule () {
      return {
        agreementCode: [
          { required: true, message: '请输入外销合同号', trigger: 'change' },
        ],

      }
    },
    detailRule () {
      return {
        productName: [
          { required: true, message: '请填写名称', trigger: 'change' },
        ],
        amount: [
          { required: true, message: '请填写单价', trigger: 'change' },
          { validator: moneyValidator, trigger: 'change' },
        ],
        companyId: [
          { required: false, message: '请选择供应商', trigger: 'change' },
        ],
        storageId: [
          { required: false, message: '请选择收货仓库', trigger: 'change' },
        ],
        count: [
          { required: true, message: '请填写数量', trigger: 'change' },
          {
            validator: function (rule, value, callback) {
              if (!isNumber(value)) {
                callback(new Error('请输入正确的数量'))
                return
              }
              callback()
            },
            trigger: 'change',
          },
        ],
      }
    },
  },
  mounted () {

  },
  activated () {
    this.queryCompanyList()
    this.queryStorageList()
    this.reset()
    this.agreementId = this.$route.query.agreementId
    this.dataForm.agreementId = this.agreementId
    if (this.$route.query.type) {
      this.type = this.$route.query.type
    }
    if (this.agreementId) {
      this.getAgreementInfoById()
    }
    this.$nextTick(() => {
      this.maxTableHeight =
          this.$refs.appContent.clientHeight -
          240
    })
  },
  methods: {
    async queryOrderDetailList () {
      const data = await this.$api2.get('/erp/order/detail/page', {
        params: {
          page: 1,
          limit: 100000000,
          orderId: this.dataForm.agreementId
        }
      })
      this.orderDetailList = data.list
    },
    async queryCompanyList () {
      const { data: res } = await this.$http.get(`/trade/company/list`)
      this.companyList = res.data
    },
    async queryStorageList () {
      const { data: res } = await this.$http.get(`/trade/storages/list`)
      this.storageList = res.data
    },
    str2Bool (str) {
      if (!str) {
        return false
      }
      return true
    },
    goBackStep () {
      this.$router.push(`/trade/agreement/save?id=${this.agreementId}`)
    },
    getAgreementInfoById () {
      let loading = this.$loading()
      this.$http
          .get(`/trade/agreement/${this.agreementId}`)
          .then(({ data: res }) => {
            loading.close()
            if (res.code !== 0) {
              return this.$message.error(res.msg)
            }
            this.dataForm.agreementCode = res.data.code
            //如果是从创建订单页面进入,自动加载所有原材料
            if (this.type == 'next') {
              this.getMaterialList()
            }
          }).catch(e => {
        loading.close()
      })
    },
    readMaterialList () {
      this.getAgreementByCode(true)
    },
    async getMaterialList () {
      if (!this.dataForm.agreementId) {
        return this.$message.error('请先选择合同')
      }
      let loading = this.$loading()
      try {
        const data = await this.$api2.post('/erp/order/detail/material/plan', {
          orderId: this.dataForm.agreementId,
          orderDetailIds: this.dataForm.orderDetailIds
        })
        this.$set(this.dataForm, 'detailList', data)
      } catch (e) {
        console.log(e)
      } finally {
        this.$nextTick(() => {
          // loading.close()
        })
      }
    },
    async agreementCodeChange () {
      this.getAgreementByCode(false)
    },
    async getAgreementByCode (readMaterial) {
      if (!this.dataForm.agreementCode) {
        return
      }
      let orderCode = this.dataForm.agreementCode
      if (orderCode.indexOf('/') > -1) {
        orderCode = orderCode.replace('/', '$-$')
      }
      let loading = this.$loading()
      try {
        const { data: res } = await this.$http
            .get(`/trade/agreement/code/${orderCode}`)
        if (res.data) {
          this.dataForm.agreementId = res.data.id
          await this.queryOrderDetailList()
          if (readMaterial) {
            await this.getMaterialList()
          }
        } else {
          this.dataForm.agreementId = ''
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.$nextTick(() => {
          loading.close()
        })
      }
    },
    delRow (index, row, dataKey) {
      this.dataForm.detailList.splice(index, 1)
    },
    addRow () {
      this.dataForm.detailList.push(this.getNewDetailRow())
    },

    //创建合同明细新行对象
    getNewDetailRow () {
      return {
        productName: '',
        code: '',
        color: '',
        size: '',
        attr1: '',
        attr2: '',
        count: '',
        companyId: '',
        storageId: '',
        amount: '',
      }
    },
    reset () {
      this.type = 'single'
      this.dataForm = {
        id: '',
        remark: '',
        totalAmount: '',
        code: '',
        currency: '美元',
        signTime: moment().format('yyyy-MM-DD'),
        customerId: '',
        agreementCode: '',
        agreementId: '',
        orderDetailIds: [],
        detailList: [],
      }
      if (this.$refs['dataForm']) {
        this.$refs['dataForm'].clearValidate()
      }
    },
    async init () {
      this.reset()
      this.$nextTick(() => {
        this.reset()
        if (this.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http
          .get(`/trade/agreement/${this.id}`)
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return this.$message.error(res.msg)
            }
            this.dataForm = {
              ...this.dataForm,
              ...res.data,
            }
          })
          .catch((e) => {
            console.log('getInfo', e)
          })
    },
    cancel () {
      this.$router.back()
    },
    go2Next () {
      this.$router.push(
          `/trade/agreement/plan/save?step=1&agreementId=${this.agreementId}`
      )
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
        function () {
          this.$refs['dataForm'].validate((valid) => {
            if (!valid) {
              return false
            }
            if (this.dataForm.detailList.length === 0) {
              return this.$message.error('原料明细不能为空')
            }
            let postForm = []
            this.dataForm.detailList.forEach((item) => {
              if (!item.storageId || !item.companyId || !item.count || item.count == 0) {
                return
              }
              postForm.push({
                ...item,
                agreementId: this.dataForm.agreementId,
              })
            })
            if (postForm.length === 0) {
              return this.$message.error('没有发现需要保存的数据,请检查')
            }
            const loading = this.$loading()
            this.$http
                .post('/trade/purchase/save', postForm)
                .then(({ data: res }) => {
                  loading.close()
                  if (res.code !== 0) {
                    return this.$message.error(res.msg)
                  }
                  this.$message({
                    message: '保存成功',
                    type: 'success',
                    duration: 500,
                    onClose: () => {
                      if (this.type == 'single') {
                        this.$router.back()
                      } else {
                        this.go2Next()
                      }
                    },
                  })
                })
                .catch((e) => {
                  console.log(e)
                  loading.close()
                })
          })
        },
        1000,
        { leading: true, trailing: false }
    ),
  },
}
</script>
